/**
 * @module businessComponents\mdl\meterTypeNavigation
 */
import Vue from "vue";
import Component from "vue-class-component";
import { MethodService } from "../../../utils/serviceModel";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class MeterTypeNavigation extends Vue {
  @Prop({ default: "" })
  private struCd!: string;

  @Prop({ default: "" })
  private keywords!: string;

  private select(item, toggle) {
    toggle();
    this.$emit("onSelected", item);
  }

  private get args() {
    let args = { stru_cd: this.struCd, keywords: this.keywords };
    return args;
  }

  private getValue(key) {
    let item = this.data[key];
    if (item) {
      return item;
    }
    return 0;
  }

  created() {
    this.svStatistic = this.$createService(
      this.module,
      this.cls,
      "statistic_type_count"
    );
  }
  mounted() {
    this.query();
  }

  @Watch("args")
  public async query() {
    try {
      let result = await this.svStatistic.invokeAsyn(this.args);
      if (result.data.isSuccess) {
        this.data = result.data.data;
        this.sum();
      } else {
        this.data = {};
      }
    } catch (error) {
      this.data = {};
    }
  }

  private sum() {
    let sum = 0;
    for (let key in this.data) {
      if (this.data.hasOwnProperty(key)) {
        let item = this.data[key];
        sum += item;
      }
    }
    this.data["-1"] = sum;
  }

  private data: IndexObject = {};

  private svStatistic: MethodService;

  private module = "mes.business.mdl.meter.service";
  private cls = "MeterService";
}
